module.exports = __webpack_public_path__ + "img/caution.f6bbd6e4.svg";